<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                无需排队
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    用户可以提前通过小程序下单并选择自提时间，到店后直接取货，避免了排队等待的时间，极大地提高了购物效率。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                灵活选择自提时间
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    用户可以根据自己的日程安排灵活选择自提时间，商家也可以根据订单量合理安排备货，减少高峰期的压力。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                自动化订单处理
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>小程序能够自动生成订单并发送给商家，减少人工录入和处理订单的时间，提高订单处理效率，降低出错率。</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                实时通知
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    小程序提供订单状态的实时更新，用户可以随时查看订单进展，如订单确认、备货完成、自提时间提醒等，提升客户满意度。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>







            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "PICK_two_column_text"
    }
</script>

<style lang="less">


</style>